import { aMapKey } from '../components/config-v2';

export const libsMap: { [key: string]: any } = {
  // echarts: 'https://staticres.linhuiba.com/libs/echarts/5.1.2/echarts-flow.min.js',
  YDPlayer: '//staticres.linhuiba.com/libs/ydplayer/20220728/ydplayer-compatible.js',
  jPlayer: '/player.js',
  subway: `//webapi.amap.com/subway?v=1.0&key=${aMapKey}&callback=cbk`,
  hls: 'https://staticres.linhuiba.com/libs/hls/1.6.7/hls.min.js'
};
